/* global LOCALE */

import { formatDateForMaistra } from '../../utils-common'

export default {
  name: 'MemberCard',
  template: `
<div class="loyalty-member-card">
  <div class="loyalty-member-card__image">
    <img src="https://res.cloudinary.com/maistra/image/upload/v1636445351/Loyalty/maistar-rewards-club.png" alt="Maistar rewards club" width="177" height="160">
  </div>

  <div class="loyalty-member-card__info">
    <span class="h4">{{ loyaltyId }}</span>
    <span class="h4" data-sl="mask">{{ memberName }}</span>
    <p v-if="memberSince" class="no-margin-bottom">{{ $t('dashboard.memberSince') }} {{ formatDateForMaistra(memberSince) }}</p>
  </div>

  <div class="loyalty-member-card__qr" data-sl="mask">
    <img v-show="qrCode" :src="qrCode" @click="$emit('enlargeQr')" width="200" />

    <p role="button" @click="$emit('enlargeQr')">{{ $t('dashboard.enlargeQr') }}</p>

    <a role="button" :title="$t('dashboard.addToAppleWallet')" @click="$emit('createApplePass')">
      <img :src="'https://res.cloudinary.com/maistra/image/upload/Loyalty/wallets/Add_to_Apple_Wallet_' + LOCALE + '.svg'" :alt="$t('dashboard.addToAppleWallet')" width="120">
    </a>
    <a role="button" :title="$t('dashboard.addToGoogleWallet')" @click="$emit('createGooglePass')">
      <img :src="'https://res.cloudinary.com/maistra/image/upload/Loyalty/wallets/add_to_google_wallet_' + LOCALE + '.svg'" :alt="$t('dashboard.addToGoogleWallet')" width="120">
    </a>
  </div>
</div>
  `,
  emits: ['enlargeQr', 'createApplePass'],
  props: {
    loyaltyId: Number,
    memberName: String,
    memberSince: Date,
    qrCode: String,
  },
  setup (props) {
    return { formatDateForMaistra, LOCALE }
  },
}
